export default __webpack_public_path__ + "static/media/search.93fc17bd.svg";